import React from 'react';
import useUserService from 'shared/api/services/userService';
import BaseDialog from 'shared/components/BaseDialog';
import { toast } from 'react-hot-toast';

function DeleteUserDialog({ open, onClose, userId, currentStatus, onSuccess }) {
    const { changeUserStatus } = useUserService();

    const handleDelete = async () => {
        try {
            const newStatus = currentStatus === 'ACTIVE' ? 'DISABLED' : 'ACTIVE';
            await changeUserStatus(userId, newStatus);
            toast.success(`User status changed to ${newStatus} successfully!`);
            onSuccess?.();
            onClose();
        } catch (error) {
            console.error('Status change failed:', error);
            toast.error(error.response?.data?.message || 'Failed to change user status');
        }
    };

    const getActionText = () => {
        return currentStatus === 'ACTIVE' ? 'DISABLE' : 'ENABLE';
    };

    return (
        <BaseDialog
            open={open}
            onClose={onClose}
            title={`Do you want to ${getActionText().toLowerCase()} the user?`}
            confirmButtonText="Confirm"
            cancelButtonText="Cancel"
            onConfirm={handleDelete}
            confirmButtonColor={currentStatus === 'ACTIVE' ? 'warning' : 'success'}
            cancelButtonColor="secondary"
        />
    );
}

export default DeleteUserDialog;
